export const formatPrice = (num:number)=>{
    if(num>=1000000) return num.toString().slice(0,1) + "'" + num.toString().slice(1).slice(0,3) + "'" + num.toString().slice(4);
    if(num>=100000) return num.toString().slice(0,3)+"'"+num.toString().slice(3);
    if(num>=10000) return num.toString().slice(0,2)+"'"+num.toString().slice(2);
    if(num>=1000) return num.toString().slice(0,1)+"'"+num.toString().slice(1);
    if(num<1000) return num;
}
